import React from "react";
import styles from "../text.module.css";
import { TitleProps } from "../TextTypes";

function Title(props: TitleProps): React.ReactElement {
  const { label } = props;

  return <h3 className={styles.title}>{label}</h3>;
}

export { Title };